import { useState } from 'react';

import { useRedeemDetailsContext } from '../contexts/redeem-details';
import { useRedeemRowsContext } from '../contexts/redeem-rows';

interface UseRedeemOffersItemProps {
  statusId: number;
}

export const useRedeemOfferItem = ({ statusId }: UseRedeemOffersItemProps) => {
  const [isRemovingRedeemItem, setIsRemovingRedeemItem] = useState(false);
  const { handleRemoveRedeemRowItem } = useRedeemRowsContext();
  const { redeemOffersStatus } = useRedeemDetailsContext();
  const isDisabledRemoveRedeemButton = statusId === 1005 || redeemOffersStatus === 'sent';

  const onRemoveRedeemItem = async (fileRowId: string, basketCustomerOfferId: string) => {
    setIsRemovingRedeemItem(true);
    await handleRemoveRedeemRowItem(basketCustomerOfferId, fileRowId);
    setIsRemovingRedeemItem(false);
  };

  return {
    isRemovingRedeemItem,
    onRemoveRedeemItem,
    isDisabledRemoveRedeemButton,
  };
};
